import { PRODUCT_LINE_CODE } from '../../../constants/product-lines-codes';
import { SHIPPING_CONDITION_CODE } from '../../../constants/shipping-conditions-codes';
import { ThreeStepsWay } from '@ordersnproducts/modules/shared/repositories/ways/three-steps.way';
import { rmsWay } from '../../ways/rms.way';

export const repo = {
  [PRODUCT_LINE_CODE.BULK_CEMENT]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: ThreeStepsWay,
    [SHIPPING_CONDITION_CODE.PICK_UP]: ThreeStepsWay,
  },
  [PRODUCT_LINE_CODE.READY_MIX]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: rmsWay,
  },
};
